import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _temp, _dec2, _class3, _class4, _temp2;

import React, { Component, PureComponent } from 'react';
import types from 'prop-types';
import { autobind } from 'core-decorators';
import { withState } from 'recompose';
import Tether, { PLACEMENTS } from '@rexlabs/tether';
import { styled, StyleSheet, keyframes } from '@rexlabs/styling';
import { noop, isArray, includes, get, isString } from 'lodash';
import Arrow from './arrow'; // HACK - Sometimes Chrome won't register mouseLeave if you
// move the cursor fast enough past the target. The below makes
// sure the tooltip never gets stuck open in a pretty brute-force way.

var HoverTarget = (_dec = styled(StyleSheet({
  hoverContainer: {
    display: 'inline-block',
    width: 'fit-content'
  }
})), _dec(_class = autobind(_class = (_temp =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HoverTarget, _PureComponent);

  function HoverTarget() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, HoverTarget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HoverTarget)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "hoverElem", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "throttleMouseMove", _.throttle(_this.handleMouseMove, 500));

    return _this;
  }

  _createClass(HoverTarget, [{
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      if (this.hoverElem.current) {
        var rect = this.hoverElem.current.getBoundingClientRect();
        var startY = rect.top;
        var startX = rect.left;
        var endY = startY + rect.height;
        var endX = startX + rect.width;

        if (e.clientX < startX || e.clientX > endX || e.clientY < startY || e.clientY > endY) {
          this.props.handleMouseLeave();
          document.body.removeEventListener('mousemove', this.throttleMouseMove);
        }
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      document.body.addEventListener('mousemove', this.throttleMouseMove);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousemove', this.throttleMouseMove);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          handleMouseLeave = _this$props.handleMouseLeave,
          s = _this$props.styles;
      return React.createElement("div", _extends({
        ref: this.hoverElem,
        children: children,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }, s('hoverContainer')));
    }
  }]);

  return HoverTarget;
}(PureComponent), _temp)) || _class) || _class);
var enterAnimation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale3d(0.7,0.7,0.7)'
  },
  '100%': {
    opacity: 1,
    transform: 'scale3d(1,1,1)'
  }
});
var exitAnimation = keyframes({
  '0%': {
    opacity: 1,
    transform: 'scale3d(1,1,1)'
  },
  '100%': {
    opacity: 0,
    transform: 'scale3d(0.7,0.7,0.7)'
  }
});
var INTERACTIONS = {
  CLICK: 'CLICK',
  HOVER: 'HOVER',
  NONE: 'NONE'
};
var InteractionsPropType = types.oneOfType([types.arrayOf(types.oneOf(_Object$values(INTERACTIONS))), types.oneOf(_Object$values(INTERACTIONS))]);
var tetherStyles = StyleSheet({
  opening: {
    animation: "".concat(enterAnimation, " forwards normal 0.25s cubic-bezier(.24,.9,.27,1)")
  },
  closing: {
    animation: "".concat(exitAnimation, " forwards normal 0.25s cubic-bezier(.24,.9,.27,1)")
  },
  content: {
    transition: 'none',
    transformOrigin: 'center'
  },
  contentTop: {
    transform: 'translateY(-.8rem)'
  },
  contentBottom: {
    transform: 'translateY(.8rem)'
  },
  contentLeft: {
    transform: 'translateX(-.8rem)'
  },
  contentRight: {
    transform: 'translateX(.8rem)'
  }
});
var defaultStyles = StyleSheet({
  tooltip: {
    display: 'block',
    padding: '1rem',
    minWidth: '10rem',
    boxSizing: 'border-box',
    margin: 0,
    background: 'white',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    position: 'relative',
    zIndex: 3
  },
  clickable: {
    cursor: 'pointer',
    position: 'relative',
    display: 'inline-block',
    '&:active:focus': {
      outline: 'none'
    }
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: 2,
    left: 0,
    top: 0
  },
  container: {
    display: 'inline-block'
  }
});
var Tooltip = (_dec2 = styled(defaultStyles), _dec2(_class3 = autobind(_class3 = (_temp2 = _class4 =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  /** Enum values for the `placement` prop. */

  /** Enum values for the `openOn` / `closeOn` prop. */

  /** @deprecated */

  /** @deprecated */

  /** @deprecated */
  function Tooltip() {
    var _this2;

    _classCallCheck(this, Tooltip);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this));

    _defineProperty(_assertThisInitialized(_this2), "_refs", {});

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isClosing: false
    });

    _defineProperty(_assertThisInitialized(_this2), "preventBodyMouseDown", false);

    _this2.contentProps = {
      toggle: _this2.toggleTooltip,
      open: _this2.openTooltip,
      close: _this2.closeTooltip
    };
    _this2.interactionSuspended = false;
    return _this2;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('mousedown', this.onBodyMouseDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousedown', this.onBodyMouseDown);
    }
  }, {
    key: "onBodyMouseDown",
    value: function onBodyMouseDown(e) {
      if (!this.preventBodyMouseDown && this.props.isOpen && this.tooltip && !this.tooltip.contains(e.target)) {
        this.closeTooltip();
      }
    }
  }, {
    key: "onEnterPress",
    value: function onEnterPress(e, callback) {
      if (e.key === 'Enter') {
        this.toggleTooltip();
      }

      if (callback) callback(e);
    }
  }, {
    key: "_canPropOn",
    value: function _canPropOn(prop, type) {
      var propVal = this.props[prop];
      return isArray(propVal) ? includes(propVal, type) : propVal === type;
    }
  }, {
    key: "canCloseOn",
    value: function canCloseOn(interactionType) {
      return this._canPropOn('closeOn', interactionType);
    }
  }, {
    key: "canOpenOn",
    value: function canOpenOn(interactionType) {
      return this._canPropOn('openOn', interactionType);
    }
  }, {
    key: "closeTooltip",
    value: function closeTooltip() {
      var _this3 = this;

      var _this$props2 = this.props,
          setOpen = _this$props2.setOpen,
          closeDuration = _this$props2.closeDuration,
          onChange = _this$props2.onChange;

      if (!this.state.isClosing || this.props.isOpen) {
        var setClosingToFalse = function setClosingToFalse() {
          setOpen(false);
          onChange({
            isOpen: false,
            isClosing: false
          });

          _this3.setState(function () {
            return {
              isClosing: false
            };
          });
        };

        clearTimeout(this.closeTimer);

        if (closeDuration > 0) {
          this.setState(function () {
            return {
              isClosing: true
            };
          });
          onChange({
            isOpen: false,
            isClosing: true
          });
          this.closeTimer = _setTimeout(setClosingToFalse, closeDuration);
        } else {
          setClosingToFalse();
        }
      }
    }
  }, {
    key: "openTooltip",
    value: function openTooltip() {
      var _this4 = this;

      clearTimeout(this.closeTimer);
      this.setState(function () {
        return {
          isClosing: false
        };
      }, function () {
        _this4.interactionSuspended = true;
        _this4.suspendedTimer = _setTimeout(function () {
          _this4.interactionSuspended = false;
        }, 500);

        _this4.props.setOpen(true);

        _this4.props.onChange({
          isOpen: true,
          isClosing: false
        });
      });
    }
  }, {
    key: "toggleTooltip",
    value: function toggleTooltip() {
      if (this.props.isOpen) {
        this.closeTooltip();
      } else {
        this.openTooltip();
      }
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      if (this.canCloseOn(INTERACTIONS.HOVER)) {
        // Bail on closing the tooltip from hovering out,
        // if we can.
        clearTimeout(this.mouseOutTimer);
      }

      if (this.canOpenOn(INTERACTIONS.HOVER)) {
        this.openTooltip();
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e) {
      if (this.canCloseOn(INTERACTIONS.HOVER)) {
        clearTimeout(this.mouseOutTimer);
        this.mouseOutTimer = _setTimeout(this.closeTooltip, this.props.hoverTimeout);
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      var onlyChild = React.Children.only(this.props.children);
      this.onEnterPress(e, get(onlyChild, 'props.onKeyPress'));
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var _this5 = this;

      if (this.props.stopPropagation) {
        e.stopPropagation();
      } // HACK: this is pretty Rex specific, when having a tooltip within an
      // iframe the iframe body will receive the click after the iframe content,
      // triggering the `onBodyMouseDown` which immediately closes the tooltip


      this.preventBodyMouseDown = true;

      _setTimeout(function () {
        _this5.preventBodyMouseDown = false;
      }, 50);

      var onlyChild = React.Children.only(this.props.children);

      if (get(onlyChild, 'props.onClick')) {
        onlyChild.props.onClick(e);
      }

      if (this.props.isOpen && this.canCloseOn(INTERACTIONS.CLICK)) {
        this.closeTooltip();
      }

      if (!this.props.isOpen && this.canOpenOn(INTERACTIONS.CLICK)) {
        clearTimeout(this.closeTimer);
        clearTimeout(this.mouseOutTimer);
        this.openTooltip();
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent(_ref) {
      var placement = _ref.placement;
      var _this$props3 = this.props,
          Content = _this$props3.Content,
          s = _this$props3.styles;
      return React.createElement("div", {
        ref: this.setRef
      }, React.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        },
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }), React.createElement("div", _extends({}, s('tooltip'), {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }), isString(Content) ? React.createElement(Content, this.contentProps) : React.createElement(Content, _extends({}, this.contentProps, {
        placement: placement
      }))));
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      this.tooltip = ref;
    }
  }, {
    key: "renderChild",
    value: function renderChild(_ref2) {
      var ref = _ref2.ref;
      var _this$props4 = this.props,
          children = _this$props4.children,
          s = _this$props4.styles,
          isOpen = _this$props4.isOpen;
      var onlyChild = React.Children.only(children);
      return this.canOpenOn(INTERACTIONS.NONE) && this.canCloseOn(INTERACTIONS.NONE) ? onlyChild : React.createElement("div", _extends({
        ref: ref,
        tabIndex: 0
      }, s('clickable'), {
        style: {
          zIndex: isOpen ? 3 : 0
        },
        onKeyPress: this.onKeyPress,
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }), onlyChild);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          s = _this$props5.styles,
          style = _this$props5.style,
          className = _this$props5.className,
          children = _this$props5.children,
          openOn = _this$props5.openOn,
          closeOn = _this$props5.closeOn,
          arrowMargin = _this$props5.arrowMargin,
          placement = _this$props5.placement,
          offset = _this$props5.offset,
          autoFlip = _this$props5.autoFlip,
          Arrow = _this$props5.Arrow,
          Content = _this$props5.Content,
          tetherStyles = _this$props5.tetherStyles,
          isOpen = _this$props5.isOpen,
          hoverTimeout = _this$props5.hoverTimeout,
          distance = _this$props5.distance,
          rest = _objectWithoutProperties(_this$props5, ["styles", "style", "className", "children", "openOn", "closeOn", "arrowMargin", "placement", "offset", "autoFlip", "Arrow", "Content", "tetherStyles", "isOpen", "hoverTimeout", "distance"]);

      var isClosing = this.state.isClosing;
      return React.createElement(HoverTarget, {
        handleMouseLeave: this.onMouseLeave
      }, isOpen ? React.createElement(Tether, _extends({}, rest, {
        offset: offset,
        styles: tetherStyles,
        arrowMargin: arrowMargin,
        distance: distance,
        placement: placement,
        Content: this.renderContent,
        autoFlip: autoFlip,
        Arrow: Arrow,
        isClosing: isClosing
      }), this.renderChild) : this.renderChild({}));
    }
  }]);

  return Tooltip;
}(Component), _defineProperty(_class4, "PLACEMENTS", PLACEMENTS), _defineProperty(_class4, "INTERACTIONS", INTERACTIONS), _defineProperty(_class4, "CLICK", INTERACTIONS.CLICK), _defineProperty(_class4, "HOVER", INTERACTIONS.HOVER), _defineProperty(_class4, "NONE", INTERACTIONS.NONE), _defineProperty(_class4, "propTypes", {
  /**
   * Content to render inside the tooltip.
   */
  content: types.node,

  /**
   * Opening trigger - click or mouse over/out.
   */
  openOn: InteractionsPropType,

  /**
   * Closing trigger - click or mouse over/out;
   */
  closeOn: InteractionsPropType,

  /**
   * Tether placement.
   */
  placement: types.oneOf(_Object$values(PLACEMENTS)),

  /**
   * Mouse out delay in ms.
   * Increase to keep the tooltip open for longer when mouse has left.
   */
  hoverTimeout: types.number,

  /**
   * Offset arrow to move it closer towards the middle of the tooltip. Any CSS unit.
   */
  arrowMargin: types.string,

  /**
   * Tooltip distance from button.
   */
  distance: types.string,

  /**
   * Offset the tooltip on its primary axis
   */
  offset: types.string,

  /**
   * Where or not to automatically reposition
   */
  autoFlip: types.bool,

  /**
   * Whether or not the Tether is about to close. Allows you to hook into
   * Tether to display closing animations.
   */
  isClosing: types.bool,

  /**
   * Whether or not to stop propagation when clicking on the tooltip button
   * Useful if you dont want your tooltip triggering other click events
   * higher in the DOM hierarchy!
   */
  stopPropagation: types.bool,

  /**
   * Function that will be run when the tooltip open/closed/closing state
   * changes. Receives an object with `isOpen` and `isClosing` properties.
   */
  onChange: types.func
}), _defineProperty(_class4, "defaultProps", {
  arrowMargin: '1.4rem',
  distance: '20px',
  offset: '0px',
  openOn: INTERACTIONS.CLICK,
  closeOn: INTERACTIONS.CLICK,
  hoverTimeout: 250,
  closeDuration: 250,
  tetherStyles: tetherStyles,
  stopPropagation: false,
  Arrow: Arrow,
  onChange: noop
}), _temp2)) || _class3) || _class3);
export default Tooltip;
var TooltipStateful = withState('isOpen', 'setOpen', false)(Tooltip);
export { TooltipStateful };